import { PageHeader } from "../../components/ui";
import ReferenceBoard from "../../components/ReferenceBoard";
import { partnerQueryKeys } from "../../api/queryKeys";
import { fetchPartnerChecklists } from "../../api/endpoints/workspace";

const checklistKey = (params) => [...partnerQueryKeys.all, "checklists", params];

const CheckListPage = () => (
  <div>
    <PageHeader title="Check list" />
    <ReferenceBoard
      queryKey={checklistKey}
      fetcher={fetchPartnerChecklists}
      searchLabel="Search a checklist"
      emptyTitle="No checklists published"
      emptyDescription="The office has not published any checklists yet."
      itemNoun="checklist"
      itemNounPlural="checklists"
      notesToggleLabel="What to collect"
    />
  </div>
);

export default CheckListPage;
